import React, { useState, useEffect } from "react";
import { Container, Card, CardBody, Nav, NavItem, NavLink, Badge } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PageGrid from "../../components/GridLayout/PageGrid";
import FieldCustomizerPanel, { useFieldCustomizer, DataTable } from "../../components/FieldCustomizer/FieldCustomizer";
import "../../components/FieldCustomizer/FieldCustomizer.css";

const ALARM_FIELDS = [
  { value:"id",          label:"ID"          },
  { value:"details",     label:"Details"     },
  { value:"time",        label:"Time"        },
  { value:"criticality", label:"Criticality" },
  { value:"occurrence",  label:"Occurrence"  },
  { value:"subscribers", label:"Subscribers" },
];

const ALARM_DEFAULT_COLS = [
  { id:"details",     label:"Details",     field:"details",     visible:true  },
  { id:"time",        label:"Time",        field:"time",        visible:true  },
  { id:"criticality", label:"Criticality", field:"criticality", visible:true  },
  { id:"occurrence",  label:"Occurrence",  field:"occurrence",  visible:true  },
  { id:"subscribers", label:"Subscribers", field:"subscribers", visible:false },
];

const MOCK_ALARMS = [
  { id:1, details:"AL: 2F North side corridor-2 AHU Return Air Temp > 27°C", time:"Today, 12:29 PM", criticality:"Critical", occurrence:"||||||", subscribers:"M Y G +2" },
  { id:2, details:"AL: 2F MR1 1 AHU OFF",                                    time:"Yesterday, 11:35 PM", criticality:"High",     occurrence:"||||",   subscribers:"M Y G +2" },
  { id:3, details:"8F Waiting Area 1 AHU Return Air Temp > 27°C",             time:"2 Days Ago, 11:05 PM",criticality:"High",     occurrence:"||||",   subscribers:"M Y G +2" },
  { id:4, details:"4F ICU 1 area temp=23 & valve position=10",                time:"14/07/2024, 10:15 PM",criticality:"Critical", occurrence:"||||||", subscribers:"M Y G +2" },
  { id:5, details:"Condenser Water Pump 4 is not in Recipe Mode",             time:"14/07/2024, 10:15 PM",criticality:"Medium",   occurrence:"|||||",  subscribers:"M Y G +2" },
];

const AlarmPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [alarms,    setAlarms]    = useState([]);

  const tableFC = useFieldCustomizer("alarms_table", [], ALARM_DEFAULT_COLS);

  useEffect(() => { setAlarms(MOCK_ALARMS); }, []);

  const filtered = activeTab === "all" ? alarms : alarms.filter(a => a.criticality.toLowerCase() === activeTab.toLowerCase());

  // Render criticality as a badge in a custom way — we wrap DataTable with a custom cell renderer
  const colorMap = { Critical:"danger", High:"warning", Medium:"info", Low:"secondary" };
  const rowsWithBadge = filtered.map(row => ({
    ...row,
    criticality: row.criticality, // raw value; DataTable will render it
  }));

  const TableContent = (
    <Card className="h-100 mb-0">
      <CardBody style={{padding:0,height:"100%",overflow:"auto"}}>
        <div className="px-3 pt-3">
          <Nav tabs className="mb-0">
            {["all","Critical","High","Medium","Low"].map(tab=>(
              <NavItem key={tab}>
                <NavLink className={activeTab===tab?"active":""} onClick={()=>setActiveTab(tab)} style={{cursor:"pointer",textTransform:"capitalize"}}>{tab}</NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>
        {/* Custom table with badge rendering for criticality */}
        <div className="table-responsive" style={{padding:"12px"}}>
          <table className="table table-hover table-bordered mb-0" style={{fontSize:13}}>
            <thead className="table-light">
              <tr>
                {tableFC.columns.filter(c=>c.visible!==false).map(col=><th key={col.id}>{col.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {rowsWithBadge.map((row,i)=>(
                <tr key={i}>
                  {tableFC.columns.filter(c=>c.visible!==false).map(col=>(
                    <td key={col.id}>
                      {col.field==="criticality"
                        ? <Badge color={colorMap[row.criticality]||"dark"}>{row.criticality}</Badge>
                        : row[col.field]??'—'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );

  const widgets = [
    {
      id:"alarms", label:"Alarm List", icon:"mdi mdi-bell-alert-outline",
      defaultW:12, defaultH:9, minH:5,
      customizer:(
        <FieldCustomizerPanel cards={[]} columns={tableFC.columns} availableFields={ALARM_FIELDS}
          onCardsChange={()=>{}} onColumnsChange={tableFC.updateCols} onReset={tableFC.resetFields}/>
      ),
      content: TableContent,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Alarms" />
          <PageGrid pageKey="alarms_page" widgets={widgets} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AlarmPage;
